(function (datatable, $) {
    /**
     * Default DataTable options that can be overriden by the param options
     */

    // DataTables only allow ascending and descending sorting. Unsorting is prevented now.
    DataTable.defaults.column.orderSequence = ['asc', 'desc'];

    datatable.defaultDatatableOptions = function (options) {
        let tableDom = "<'row'<'col-sm-12'tr>>";
        if (options?.hideFooter !== true) {
            tableDom += "<'row'<'col-sm-12 col-md-9 d-flex'l<'px-2'i>><'col-sm-12 col-md-3 dataTables_pager'p>>"
        }

        let defaultOptions = {
            dom: tableDom,
            retrieve: true,
            autoWidth: options?.autoWidth ?? false,
            processing: options?.processing ?? false,
            serverSide: options?.serverSide ?? true,
            pageLength: options?.pageLength ?? 25,
            lengthMenu: options?.lengthMenu ?? [25, 50, 100],
            stateSave: options?.stateSave ?? true,
            ajax: {
                type: 'POST',
                data: function (data) {
                    let requestVerificationToken = $("[name='__RequestVerificationToken']");

                    if (requestVerificationToken.length > 0)
                        data.__RequestVerificationToken = requestVerificationToken.val();
                }
            },
            language: dutchSettings,
            fnServerParams: function (data) {
                data['order'].forEach(function (items, index) {
                    data['order'][index]['column'] = data['columns'][items.column]['name'];
                });
            },
            initComplete: function () {
                let $table = $(this);
                let api = this.api();
                let table = api.table();

                $(document).on("click", ".nav-link", function () {
                    var href = $(this).attr("href");
                    var parent = $table.parents(href);
                    if (parent.length > 0)
                        table.draw();
                });

                let anySearchable = api.columns().flatten().toArray().some(index => api.column(index).context[0].aoColumns[index].searchable);
                if (anySearchable) {
                    let rowFilter = $('<tr class="filter"></tr>').appendTo($(table.header()));

                    api.columns().flatten().each(function (index) {
                        let input = null;
                        let column = api.column(index);
                        let title = $(column.header()).text().trim();

                        if (options?.initCompleteColumn) {
                            input = options.initCompleteColumn(column);
                        }

                        if (input == null) {
                            switch (title) {
                                case 'Acties':
                                case '':
                                    let search = $(`<button class="btn btn-sm btn-outline-primary ms-2 px-3"><i class="fas fa-magnifying-glass"> </i></button>`);
                                    let reset = $(`<button class="btn btn-sm btn-outline-secondary ms-2 px-3"><i class="fas fa-circle-xmark"> </i></button>`);
                                    $('<th class="mx-1" nowrap></th>').append(search).append(reset).appendTo(rowFilter);

                                    $(search).on('click', function (e) {
                                        e.preventDefault();
                                        datatable.dataTableSearch(rowFilter, table);
                                    });

                                    $(reset).on('click', function (e) {
                                        e.preventDefault();
                                        $(rowFilter).find('.datatable-input').each(function (i) {
                                            $(this).val('');
                                            table.column($(this).data('col-index')).search('', false, false);
                                        });
                                        table.draw();
                                    });
                                    break;
                                default:
                                    let searchable = column.context[0].aoColumns[index].searchable;
                                    if (searchable) {
                                        let enumeration = column.context[0].aoColumns[index].enum;
                                        if (enumeration != null) {
                                            input = $('<select>').addClass("form-select form-select-sm datatable-input").attr({ "data-col-index": index })

                                            let multiselect = column.context[0].aoColumns[index].multiselect;
                                            if (multiselect) {
                                                input.attr("multiple", "multiple");
                                            }
                                            else {
                                                input.append($("<option />", { value: "", text: "Selecteer" }));
                                            }

                                            $.each(enumeration, function (index, item) {
                                                if (item.index !== undefined)
                                                    $(input).append('<option value="' + item.index + '">' + item.title + '</option>');
                                                else if (item.value !== undefined)
                                                    $(input).append('<option value="' + item.value + '">' + item.title + '</option>');
                                                else
                                                    $(input).append('<option value="' + item.title + '">' + item.title + '</option>');
                                            });

                                            input.on("change", function () {
                                                datatable.dataTableSearch(rowFilter, table);
                                            });

                                        } else {
                                            input = $(`<input type="text" class="form-control form-control-sm form-filter datatable-input" data-col-index="` + column.index() + `"/>`);
                                            input.on('keypress', function (e) {
                                                if (e.which === 13) {
                                                    datatable.dataTableSearch(rowFilter, table);
                                                    return false;
                                                }
                                            });
                                        }

                                        // Restore state saved values
                                        let state = this.state.loaded();
                                        if (state) {
                                            let val = state.columns[index];
                                            input.val(val.search.search);
                                        }

                                        break;
                                    }
                            }
                        }

                        if (title !== '' && title !== 'Acties') {
                            $(input).appendTo($('<th></th>').appendTo(rowFilter));
                        }

                        if (options?.initCompletePost)
                            options.initCompletePost();
                    });
                }

                if (options?.columnDefs) {
                    options.columnDefs.forEach(function (columnDef) {
                        if (columnDef.fixed === true) {
                            let targets = [];
                            targets.push(columnDef.targets);

                            targets.forEach(function (index) {
                                let column = api.columns(index);
                                let width = column.header()[0].style['width'];

                                if (width !== undefined && width !== null) {
                                    column.header()[0].style['max-width'] = width;
                                    column.header()[0].style['min-width'] = width;
                                }
                            });
                        }
                    });
                }

                $("th", table.header()).addClass("pb-2")

                if (defaultOptions.postInitComplete !== undefined) {
                    defaultOptions.postInitComplete();
                }

                if (table.page.info().page > 0 && table.rows()[0].length == 0) {
                    // Wait 1 millisecond for this init function to finish, else table doesn't update rows
                    window.setTimeout(function () {
                        datatable.dataTableSearch(rowFilter, table)
                    }, 1);
                }
            },
            postInitComplete: function () {
                //    $('select[multiple]').select2({
                //        tags: false,
                //        selectionCssClass: 'form-select form-select-sm datatable-input'
                //    });
            }
        };

        $.extend(true, defaultOptions, options);

        if (defaultOptions.columnDefs) {
            defaultOptions.columnDefs = defaultOptions.columnDefs.concat([
                {
                    targets: "_all",
                    render: function (data, type, full, meta) {
                        if (defaultOptions.columns[meta.col].enum !== undefined) {
                            return datatable.dataTableEnum(data, meta);
                        }
                        return datatable.display(data);
                    }
                }
            ]);
        }

        return defaultOptions;
    }

    /**
     * Method that is used for searching for each column
     */
    datatable.dataTableSearch = function (rowFilter, table) {
        let params = {};

        $(rowFilter).find('.datatable-input').each(function () {
            let i = $(this).data('col-index');
            if (params[i]) {
                params[i] += '|' + $(this).val();
            } else {
                params[i] = $(this).val();
            }
        });

        $.each(params, function (i, val) {
            if (Array.isArray(val)) {
                val = val.join(';');
            }

            // Apply search params to datatable
            table.column(i).search(val ? val : '', false, false);
        });

        table.draw();
    }

    /**
     * Method that renders the enum for an icon or a label
     */
    datatable.dataTableEnum = function (data, meta) {
        let column = meta.settings.aoColumns[meta.col];
        if (!column)
            return datatable.display(data);

        let enumeration = column.enum;
        if (!enumeration)
            return datatable.display(data);

        let value = enumeration.find((item) => item.index === data || item.value === data);
        if (value) {
            if (value.class) {
                if (value.icon === true)
                    return '<i class="' + datatable.display(value.class) + '" title="' + datatable.display(value.title) + '"></i>';
                else
                    return '<span class="' + datatable.display(value.class) + '">' + datatable.display(value.title) + '</span>';
            }
            return datatable.display(value.title);
        }
        return datatable.display(data);
    }

    /**
     * Wrapper for displaying a value
     */
    datatable.display = function (data) {
        return $.fn.dataTable.render.text().display(data);
    }

    /**
     * Method to format date time values
     * By default use DD-MM-YYYY HH:mm:ss
     */
    datatable.dutchDateFormat = function (data, customFormat) {
        let dateFormat = customFormat ?? "DD-MM-YYYY HH:mm:ss";
        if (data !== undefined && data !== "0001-01-01T00:00:00")
            return moment(data).locale("nl").format(dateFormat);
        else
            return "";
    }

}(window.datatable = window.datatable || {}, $));

var dutchSettings =
{
    "lengthMenu": "_MENU_ resultaten weergeven",
    "zeroRecords": "Geen resultaten gevonden",
    "infoEmpty": "Geen resultaten om weer te geven",
    "search": "Zoeken:",
    "emptyTable": "Geen resultaten aanwezig in de tabel",
    "infoThousands": ".",
    "loadingRecords": "Een moment geduld aub - bezig met laden...",
    "paginate": {
        "first": "Eerste",
        "last": "Laatste",
        "next": "Volgende",
        "previous": "Vorige"
    },
    "aria": {
        "sortAscending": ": activeer om kolom oplopend te sorteren",
        "sortDescending": ": activeer om kolom aflopend te sorteren"
    },
    "autoFill": {
        "fill": "Vul alle cellen met <i>%d<\/i>",
        "fillHorizontal": "Vul cellen horizontaal",
        "fillVertical": "Vul cellen verticaal",
        "cancel": "Annuleren",
        "info": "Voorbeeld automatisch aanvullen info"
    },
    "buttons": {
        "colvis": "Kolom zichtbaarheid",
        "colvisRestore": "Herstel zichtbaarheid",
        "copy": "Kopieer",
        "copySuccess": {
            "1": "1 regel naar klembord gekopieerd",
            "_": "%ds regels naar klembord gekopieerd"
        },
        "copyTitle": "Kopieer naar klembord",
        "csv": "CSV",
        "excel": "Excel",
        "pageLength": {
            "-1": "Toon alle regels",
            "_": "Toon %d regels",
            "1": "Toon 1 rij"
        },
        "pdf": "PDF",
        "print": "Print",
        "copyKeys": "Klik ctrl of u2318 + C om de tabeldata to kopi�ren naar je klembord. Om te annuleren klik hier of klik op escape.",
        "collection": "Verzameling",
        "createState": "Maak staat",
        "removeAllStates": "Verwijder alle",
        "removeState": "Verwijder",
        "renameState": "Hernoem",
        "savedStates": "Opgeslagen",
        "updateState": "Bijwerken",
        "stateRestore": "Preset %d"
    },
    "processing": "Verwerken...",
    "decimal": ",",
    "searchBuilder": {
        "add": "Toevoegen",
        "clearAll": "Verwijder alles",
        "condition": "Conditie",
        "data": "Data",
        "deleteTitle": "Verwijder",
        "value": "Waarde",
        "conditions": {
            "date": {
                "after": "Na",
                "before": "Voor",
                "between": "Tussen",
                "empty": "Leeg",
                "equals": "Gelijk aan",
                "not": "Niet",
                "notBetween": "Niet tussen",
                "notEmpty": "Niet leeg"
            },
            "number": {
                "between": "Tussen",
                "empty": "Leeg",
                "equals": "Gelijk aan",
                "gt": "Groter dan",
                "gte": "Groter dan of gelijk aan",
                "lt": "Kleiner dan",
                "lte": "kleiner dan of gelijk aan",
                "not": "Niet",
                "notBetween": "Niet tussen",
                "notEmpty": "Niet leeg"
            },
            "string": {
                "contains": "Bevat",
                "empty": "Leeg",
                "endsWith": "Eindigt met",
                "equals": "Gelijk aan",
                "not": "Niet",
                "notEmpty": "Niet leeg",
                "startsWith": "Start met",
                "notContains": "Zonder",
                "notEndsWith": "Eindigt niet met",
                "notStartsWith": "Begint niet met"
            },
            "array": {
                "equals": "Gelijk aan",
                "empty": "Leeg",
                "contains": "Bevat",
                "not": "Niet",
                "notEmpty": "Niet leeg",
                "without": "Zonder"
            }
        },
        "logicAnd": "En",
        "logicOr": "Of",
        "button": {
            "0": "Zoekwizard",
            "_": "Zoekwizard (%d)"
        },
        "leftTitle": "Afwijkende criteria",
        "rightTitle": "Criteria inspringen",
        "title": {
            "0": "Zoekwizard",
            "_": "Zoekwizard (%d) "
        }
    },
    "searchPanes": {
        "clearMessage": "Alles leegmaken",
        "collapse": {
            "0": "Zoekpanelen",
            "_": "Zoekpanelen (%d)"
        },
        "count": "{total}",
        "countFiltered": "{shown} ({total})",
        "emptyPanes": "Geen zoekpanelen",
        "loadMessage": "Zoekpanelen laden...",
        "title": "%d filters actief",
        "showMessage": "Alles weergeven",
        "collapseMessage": "Instorten"
    },
    "select": {
        "cells": {
            "1": "1 cel geselecteerd",
            "_": "%d cellen geselecteerd"
        },
        "columns": {
            "1": "1 kolom geselecteerd",
            "_": "%d kolommen geselecteerd"
        },
        "rows": {
            "1": "1 rij geselecteerd",
            "_": "%d rijen geselecteerd"
        }
    },
    "thousands": ".",
    "info": "_START_ tot _END_ van _TOTAL_ resultaten",
    "infoFiltered": " (gefilterd uit _MAX_ resultaten)",
    "datetime": {
        "previous": "Vorige",
        "next": "Volgende",
        "hours": "Uur",
        "minutes": "Minuut",
        "seconds": "Seconde",
        "unknown": "Onbekend",
        "amPm": [
            "vm",
            "nm"
        ],
        "weekdays": [
            "Zo",
            "Ma",
            "Di",
            "Wo",
            "Do",
            "Vr",
            "Za"
        ],
        "months": [
            "Januari",
            "Februari",
            "Maart",
            "April",
            "Mei",
            "Juni",
            "Juli",
            "Augustus",
            "September",
            "Oktober",
            "November",
            "December"
        ]
    },
    "editor": {
        "close": "Sluiten",
        "create": {
            "button": "Nieuw",
            "title": "Voeg nieuwe gegevens toe",
            "submit": "Toevoegen"
        },
        "edit": {
            "button": "Wijzigen",
            "title": "Wijzig gegevens",
            "submit": "Wijzigen"
        },
        "remove": {
            "button": "Verwijderen",
            "title": "Verwijder",
            "submit": "Verwijder",
            "confirm": {
                "_": "Bent u zeker dat u %d rijen wil verwijderen?",
                "1": "Bent u zeker dat u 1 rij wil verwijderen?"
            }
        },
        "error": {
            "system": "Er is een fout gebeurd"
        },
        "multi": {
            "title": "Meerdere waarden",
            "info": "De geselecteerde items bevatten verschillende waarden voor deze invoer. Om alle items voor deze invoer op dezelfde waarde te zetten, klik of tik hier, zoniet zullen de individuele waarden behouden blijven.",
            "restore": "Wijzigingen ongedaan maken",
            "noMulti": "Deze invoer kan individueel gewijzigd worden, maar niet als deel van een groep."
        }
    },
    "stateRestore": {
        "creationModal": {
            "button": "Aanmaken",
            "columns": {
                "search": "Zoeken in kolom",
                "visible": "Kolom tonen"
            },
            "name": "Naam",
            "order": "Sorteervolgorde",
            "paging": "Paginering",
            "scroller": "Meescrollen",
            "search": "Zoeken",
            "searchBuilder": "SearchBuilder",
            "select": "Selecteer",
            "title": "Nieuwe staat aanmaken",
            "toggleLabel": "Bevat"
        },
        "duplicateError": "Staat bestaat al",
        "emptyError": "Naam kan niet leeg zijn",
        "emptyStates": "Geen beschikbare staten",
        "removeConfirm": "Weet u zeker dat u deze wil verwijderen:",
        "removeError": "De verwijdering is mislukt",
        "removeJoiner": "en",
        "removeSubmit": "Verwijder",
        "removeTitle": "Verwijder staat",
        "renameButton": "Hernoem",
        "renameLabel": "Nieuwe naam voor staat",
        "renameTitle": "Hernoem staat"
    }
}
